import { Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../../core';
import { entResult } from '../../entities/entResult';
import { Observable } from 'rxjs';
import { entActiveUser } from '../../entities/entActiveUser';
import { map } from "rxjs/operators";

@Injectable()
export class PeticionCoordenadasGuard implements CanActivate{
    
    userActive: entActiveUser;

    constructor(private router: Router,
                private http: HttpClient) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {

        // Si existe la ruta
        if (route.url != null && route.url.length === 2) {

            this.userActive  = {
                CodeHMAC: route.paramMap.get('hmac'),
                CodeUser: null,
                Name: null,
                CodCard: null,
                Card_Blocked: null,
                Num_Attemps: null,
                ActivSn: null,
                Url_Active: null,
                FechaEnvDt: null,
                Password: null,
                ConfirmPassword: null,
                Inserted_Coord_Value: null,
                SystemUrl: null
                };

                // Se sustituyen todos los strings por el símbolo real del HMAC.
                while (this.userActive.CodeHMAC.match('CADENAMAS')) {
                    this.userActive.CodeHMAC = this.userActive.CodeHMAC.replace('CADENAMAS','+');
                }

            let self = this;

            return this.http.post<entResult>(Constants.EndPoints.User.GetPotentialUser,this.userActive).pipe(map((result) => {
                    if (result != null)
                    {
                        if (result.ExistErrors)
                        {
                            this.router.navigate(['/CentroContacto']);
                            return false;
                        }
                        else
                        {
                            if (result.Result != null)
                            {                                                           
                                if (!result.Result.Url_Active)
                                {
                                    this.router.navigate(['/UrlCaducada']);
                                    return false;
                                }
                                else if(result.Result.Card_Blocked) 
                                {
                                    this.router.navigate(['/CentroContacto']);
                                    return false;
                                }
                                return true;
                            }
                            else
                            {
                                this.router.navigate(['/CentroContacto']);
                                    return false;
                            
                            }
                        }
                    }
                    else
                    {
                        this.router.navigate(['/CentroContacto']);
                        return false;
                    }
                  }));

        } else {
            this.router.navigate(['/CentroContacto']);;
            return false;
        };  
     }
}
